// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"BottomBarCancel_modalWrapper__MuKDn","modalTitle":"BottomBarCancel_modalTitle__Bxzzq","modalButtonsWrapper":"BottomBarCancel_modalButtonsWrapper__3a3fw"};